module.exports = __webpack_public_path__ + "img/logobg.a8527b55.png";